var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('AppBar'),_c('v-main',{staticClass:"mb-10 mt-4"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }